<template>
<div class="chapter">
<div class="inner_page">
<h1 class="toc-title"><a id="page_vii">Contents</a></h1><a id="page_vii">
</a><p class="toc-fm"><a id="page_vii"></a><a href="#/007_Preface#fm-1">Preface</a></p>
<p class="toc-fm"><a href="#/008_Preface02#fm-2">Preface to the Second Edition</a></p>
<p class="toc-fm"><a href="#/009_Intro#fm-3">Introduction: Images of a Heresy</a></p>
<p class="toc-part"><a href="#/010_Part01#pt-1">Part I Arius and the Nicene Crisis</a></p>
<p class="toc-chap"><a href="#/011_Chapter01#ch-1">A Arius before Arianism</a></p>
<p class="toc-sec"><a href="#/011_Chapter01#sec-1">1 Origins</a></p>
<p class="toc-sec"><a href="#/011_Chapter01#sec-2">2 The Troubles of the Alexandrian Church I: The Melitian Schism</a></p>
<p class="toc-sec"><a href="#/011_Chapter01#sec-3">3 The Troubles of the Alexandrian Church II: Bishops and Presbyters</a></p>
<p class="toc-chap"><span href="#/012_Chapter02#ch-2" title="Link target outside of Sample">B The Nicene Crisis: Documents and Dating</span></p>
<p class="toc-sec"><span href="#/012_Chapter02#sec-4" title="Link target outside of Sample">1 The Controversy to 325</span></p>
<p class="toc-sec"><span href="#/012_Chapter02#sec-5" title="Link target outside of Sample">2 The <em>Thalia</em></span></p>
<p class="toc-sec"><span href="#/012_Chapter02#sec-6" title="Link target outside of Sample">3 Nicaea and After</span></p>
<p class="toc-chap"><span href="#/013_Chapter03#ch-3" title="Link target outside of Sample">C Conclusion</span></p>
<p class="toc-part"><span href="#/014_Part02#pt-2" title="Link target outside of Sample">Part II Arius and Theology</span></p>
<p class="toc-chap"><span href="#/015_Chapter04#ch-4" title="Link target outside of Sample">A The Theology of Arius</span></p>
<p class="toc-chap"><span href="#/016_Chapter05#ch-5" title="Link target outside of Sample">B Alexandria and the Legacy of Origen</span></p>
<p class="toc-sec"><span href="#/016_Chapter05#sec-7" title="Link target outside of Sample">1 Philo</span></p>
<p class="toc-sec"><span href="#/016_Chapter05#sec-8" title="Link target outside of Sample">2 Clement</span></p>
<p class="toc-sec"><a id="page_viii"></a><span href="#/016_Chapter05#sec-9" title="Link target outside of Sample">3 Origen</span></p>
<p class="toc-sec"><span href="#/016_Chapter05#sec-10" title="Link target outside of Sample">4 Alexandria after Origen</span></p>
<p class="toc-chap"><span href="#/017_Chapter06#ch-6" title="Link target outside of Sample">C Theology Outside Egypt</span></p>
<p class="toc-sec"><span href="#/017_Chapter06#sec-11" title="Link target outside of Sample">1 Antioch</span></p>
<p class="toc-sec"><span href="#/017_Chapter06#sec-12" title="Link target outside of Sample">2 Methodius and Eusebius</span></p>
<p class="toc-chap"><span href="#/018_Chapter07#ch-7" title="Link target outside of Sample">D Conclusion</span></p>
<p class="toc-part"><span href="#/019_Part03#pt-3" title="Link target outside of Sample">Part III Arius and Philosophy</span></p>
<p class="toc-chap"><span href="#/020_Chapter08#ch-8" title="Link target outside of Sample">A Creation and Beginning</span></p>
<p class="toc-chap"><span href="#/021_Chapter09#ch-9" title="Link target outside of Sample">B Intellect and Beyond</span></p>
<p class="toc-chap"><span href="#/022_Chapter10#ch-10" title="Link target outside of Sample">C Analogy and Participation</span></p>
<p class="toc-chap"><span href="#/023_Chapter11#ch-11" title="Link target outside of Sample">D Conclusion</span></p>
<p class="toc-bm1"><span href="#/024_Post#bm-1" title="Link target outside of Sample">Postscript (Theological)</span></p>
<p class="toc-bm"><span href="#/025_App01#bm-2" title="Link target outside of Sample">Appendix 1: Arius since 1987</span></p>
<p class="toc-bm"><span href="#/026_App02#bm-3" title="Link target outside of Sample">Appendix 2: Credal Documents</span></p>
<p class="toc-bm1"><span href="#/027_Endnotes#bm-4" title="Link target outside of Sample">Notes</span></p>
<p class="toc-bm"><span href="#/028_Abberviations#bm-5" title="Link target outside of Sample">Abbreviations</span></p>
<p class="toc-bm"><span href="#/029_Bibliography#bm-6" title="Link target outside of Sample">Bibliography</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 006_Contents.vue?f5a982c0